<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Add Lead
    </h1>
    <div class="l-bg-white">
      <form @submit.prevent="save"
            @keydown="clearError($event)"
            autocomplete="no"
      >
        <div class="row">
          <div class="col-md-12 mb-0">
            <h4>Company Info</h4>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6 pr-md-1">
            <div class="select-wrap">
              <label>Company</label>
              <simple-select v-model="lead.company_id"
                             v-if="companies"
                             :options="companies.filter(c => c.status_id === 1)"
                             placeholder="Select Company"
                             @input="setCompany"
              />
            </div>
            <error-field :errors="errors" field="company_id" />
          </div>
          <div class="col-md-6 pl-md-1">
            <div class="select-wrap" :class="{'disabled': unlockedFields === true}">
              <label>Move size</label>
              <simple-select v-model="lead.move_size_id"
                             :options="move_sizes"
                             :disabled="unlockedFields === true"
                             placeholder="Select Move Size"
              />
            </div>
            <error-field :errors="errors" field="move_size_id" />
          </div>
          <div class="col-md-6 pr-md-1">
            <div class="select-wrap" :class="{'disabled': unlockedFields === true}">
              <label>Arrival window</label>
              <simple-select v-model="lead.arrival_window_id"
                             :options="arrival_windows"
                             label="label"
                             :disabled="unlockedFields === true"
                             placeholder="Select Arrival Window"
              />
            </div>
            <error-field :errors="errors" field="arrival_window_id" />
          </div>
          <div class="col-md-6 pl-md-1">
            <div class="select-wrap" :class="{'disabled': unlockedFields === true}">
              <label>Source</label>
              <simple-select v-model="lead.source_id"
                             :options="sources"
                             placeholder="Select Source"
              />
            </div>
            <error-field :errors="errors" field="source_id" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12 check-field">
            <label for="show-movers"
                   :class="{'check-open' : showMoversAndTrucks === true}"
            ><span
              class="checkmark"
            /> Show movers and trucks
              <input type="checkbox"
                     id="show-movers"
                     v-model="showMoversAndTrucks"
                     class="btn-check"
              />
            </label>
          </div>
        </div>
        <div class="row mb-3" v-show="showMoversAndTrucks">
          <div class="col-md-6 pr-md-1">
            <div class="select-wrap">
              <label>Movers</label>
              <simple-select v-model="lead.movers"
                             :options="numberOfMovers"
                             placeholder="Select Number of Movers"
              />
            </div>
            <error-field :errors="errors" field="movers" />
          </div>
          <div class="col-md-6 pl-md-1">
            <div class="select-wrap">
              <label>Trucks</label>
              <input v-model="lead.trucks" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="trucks" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12 mb-0">
            <h4>Customer Info</h4>
          </div>
          <div class="col-md-6 pr-md-1">
            <div class="select-wrap"
                 :class="{'searching-border':searchingDuplicateLeads && lead.phone}"
            >
              <label>Customer phone</label>
              <input v-model="lead.phone" type="text"
                     class="form-control"
                     :disabled="disabledCustomer"
                     @keydown="maskMainPhone($event)"
                     @blur="searchDuplicateLeads"
                     @input="clearDuplicateLeads"
                     placeholder="Enter Phone"
                     maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
          <div class="col-md-6 pl-md-1">
            <div class="select-wrap"
                 :class="{'searching-border':searchingDuplicateLeads && lead.email}"
            >
              <label>Customer email</label>
              <input v-model="lead.email"
                     @blur="searchDuplicateLeads"
                     @input="clearDuplicateLeads"
                     type="text" class="form-control"
                     :disabled="disabledCustomer"
                     placeholder="Enter Email"
              />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-md-6 pr-md-1">
            <div class="select-wrap">
              <label>Customer first name</label>
              <input v-model="lead.first_name"
                     type="text"
                     class="form-control"
                     :disabled="disabledCustomer"
                     placeholder="Enter Name"
              />
            </div>
            <error-field :errors="errors" field="first_name" />
          </div>
          <div class="col-md-6 pl-md-1">
            <div class="select-wrap">
              <label>Customer last name</label>
              <input v-model="lead.last_name"
                     type="text"
                     class="form-control"
                     :disabled="disabledCustomer"
                     placeholder="Enter Last Name"
              />
              <error-field :errors="errors" field="last_name" />
            </div>
          </div>
          <div class="col-md-12 check-field">
            <label for="make-mod"
                   :class="{'check-open' : lead.make_mod_customer === true}"
            ><span
              class="checkmark"
            /> Make this customer a Mod24 customer
              <input type="checkbox"
                     id="make-mod"
                     v-model="lead.make_mod_customer"
                     class="btn-check"
              />
            </label>
          </div>
        </div>
        <!-- Additional contacts -->
        <div v-for="(contact, index) in lead.contacts"
             :key="contact.id"
        >
          <div class="row mb-3">
            <div class="col-md-12 mt-3 mb-0" v-if="index === 0">
              <h4>Additional Contacts</h4>
            </div>
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-6 pr-md-1">
                  <div class="select-wrap">
                    <label>Email</label>
                    <input v-model="contact.email"
                           type="email"
                           class="form-control"
                           placeholder="Enter Email"
                    />
                  </div>
                  <error-field :errors="errors" :field="`contacts.${index}.email`" />
                </div>
                <div class="col-md-6 pl-md-1">
                  <div class="select-wrap">
                    <label>Phone</label>
                    <input v-model="contact.phone"
                           type="text"
                           class="form-control"
                           @keydown="maskAdditionalPhone(index, $event)"
                           placeholder="Enter Phone"
                           maxlength="14"
                    />
                  </div>
                  <error-field :errors="errors" :field="`contacts.${index}.phone`" />
                </div>
              </div>
            </div>
            <div class="col-md-1 pl-3">
              <button type="button" class="btn btn-clear" @click="removeContact(index)">
                <span class="mod-icon-clear" />
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn add-button" @click="addAdditionalContact">
              <span><span
                class="mod-icon-add"
              /></span>Add
              additional contact
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="select-wrap select-date">
              <label>Move date</label>
              <flat-pickr v-model="lead.move_date"
                          :config="config"
                          class="form-control"
                          placeholder="Select move date"
              />
            </div>
            <error-field :errors="errors" field="move_date" />
          </div>
        </div>

        <div v-for="(address, index) in lead.addresses"
             :key="address.id"
        >
          <div class="row mb-3 create-lead" :key="index">
            <div class="col-1 text-left" :class="{'border-h-animate': index < lead.addresses.length - 1}">
              <i class="fa fa-circle" :class="[address.type_id === 1 ? 'c-pickup' : 'c-delivery']" />
            </div>
            <div class="col-md-11">
              <div class="btn-group btn-group-toggle mb-3">
                <div class="btn" :class="{'btn-primary': address.type_id === 1}" @click="address.type_id = 1">
                  <input type="radio" name="options" autocomplete="off" checked /> Pickup
                </div>
                <div class="btn" :class="{'btn-primary': address.type_id === 2}" @click="address.type_id = 2">
                  <input type="radio" name="options" autocomplete="off" /> Delivery
                </div>
              </div>
            </div>
            <div class="col-1" />
            <div class="col-md-10">
              <div class="row mb-3">
                <div class="col-md-12">
                  <div class="select-wrap">
                    <label>Address</label>
                    <input v-model="address.full_address" type="text" class="form-control"
                           @input="getAddressData(address.full_address, index)"
                           @keydown.prevent.down="$event.target.nextElementSibling.firstChild.focus()"
                    />
                    <div class="dropdown-menu show address-field-wrap" aria-labelledby="dropdownMenu2"
                         v-if="showDropdown[index] === true && addresses[index]"
                    >
                      <button type="button"
                              class="dropdown-item"
                              v-for="addressItem in addresses[index]"
                              :key="addressItem.id"
                              @click="setAddress(addressItem, index)"
                              @keydown.prevent.down="$event.target.nextElementSibling.focus()"
                              @keydown.up="$event.target.previousElementSibling.focus()"
                      >
                        {{ addressItem.full_address }}
                      </button>
                    </div>
                  </div>
                  <error-field :errors="errors" :field="`addresses.${index}.postal_code`" />
                </div>
                <div class="col-6 col-md-6 pr-1">
                  <div class="select-wrap">
                    <label>Floor</label>
                    <input v-model="address.floor" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-6 col-md-6 pl-1">
                  <div class="select-wrap">
                    <label>Apartment</label>
                    <input v-model="address.apartment" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1 pl-3">
              <a href="#" class="btn btn-clear" @click="removeAddress(index)"><span class="mod-icon-clear" /></a>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12">
            <button class="btn add-button" type="button" @click="addAddress">
              <span><span
                class="mod-icon-add"
              /></span>Add
              address
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col text-right">
            <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
              Cancel
            </button>
            <button class="btn btn-primary ld-ext-right"
                    :disabled="buttonDisabled"
                    :class="loadingButton ? 'running' : ''"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import flatPickr from 'vue-flatpickr-component';
import _ from 'lodash';
import ErrorField from '../ErrorField';
import Errors from '../../classes/Errors';
import 'flatpickr/dist/flatpickr.css';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'LeadsCreate',
  components: {
    ErrorField,
    flatPickr,
  },
  props: {
    customer: {
      type: Object,
      default: null,
    },
    searchingDuplicateLeads: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    lead: {
      addresses: [
        {
          street_name: '',
          state_id: 0,
          city: '',
          postal_code: '',
          apartment: '',
          type_id: 1,
        },
      ],
      contacts: [],
      arrival_window_id: '',
      cluster_user: [],
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      make_mod_customer: false,
      move_date: '',
      move_size_id: '',
      movers: '',
      notes: '',
      route_id: '',
      source_id: '',
      status: '',
      trucks: 1,
    },
    phone: '',
    email: '',
    move_sizes: [],
    arrival_windows: [],
    sources: [],
    customers: [],
    numberOfMovers: [],
    address: null,
    addresses: [],
    showDropdown: [
      {
        0: false,
      },
    ],
    disabledCustomer: false,
    config: {
      dateFormat: 'm/j/Y',
      minDate: 'today',
    },
    showMoversAndTrucks: false,
    loadingButton: false,
    buttonDisabled: false,
    unlockedFields: true,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      user: state => state.auth.dispatchUser,
      companies: state => state.companies.companies.data,
    }),
  },
  mounted() {
    if (this.$route.query.customer_id) {
      this.disabledCustomer = true;
      this.lead.customer_id = this.customer.id;
      this.lead.first_name = this.customer.first_name;
      this.lead.last_name = this.customer.last_name;
      this.lead.email = this.customer.email;
      this.lead.phone = this.customer.phone;
    }
    this.$nextTick(() => {
      window.$('input').attr('autocomplete', 'no');
    });
  },
  methods: {
    save() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .post(`leads`, { ...this.lead })
        .then(res => {
          if (res.data.error && res.data.error.postal_code) {
            toastr.warning('Some addresses are not covered by the company', '', { timeOut: 0 });
            this.loadingButton = false;
            this.buttonDisabled = false;
          } else {
            toastr.success('Successfully created lead');
            this.loadingButton = false;
            this.buttonDisabled = false;
          }
          this.$router.push(`/leads/edit/${res.data.data.id}`);
        })
        .catch(err => {
          if (err.response.data.error.duplicate) {
            toastr.error(err.response.data.error.duplicate);
          } else {
            this.errors.record(err.response.data.error);
          }
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    searchDuplicateLeads() {
      if (this.lead.company_id) {
        if (this.lead.phone || this.lead.email) {
          this.phone = this.lead.phone;
          this.email = this.lead.email;
          this.$emit('leads-search', this.lead);
        }
      }
    },
    clearDuplicateLeads() {
      if (this.phone && this.email) {
        this.$emit('leads-clear');
      }
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    addAddress() {
      this.lead.addresses.push({
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
        type_id: 1,
        zip: null,
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
      });
    },
    removeAddress(index) {
      this.errors.clear();
      this.lead.addresses.splice(index, 1);
    },
    setCompany() {
      this.unlockFields();
      this.searchDuplicateLeads();
      this.getMoveSizes();
      this.getArrivalWindows();
      this.getSources();
      this.getNumberOfMovers();
    },
    unlockFields() {
      this.unlockedFields = false;
    },
    getMoveSizes() {
      axios
        .get(`companies/${this.lead.company_id}/move-sizes`)
        .then(result => {
          this.move_sizes = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getArrivalWindows() {
      axios
        .get(`companies/${this.lead.company_id}/arrival-windows`)
        .then(result => {
          result.data.data.forEach(arrivalWindow => {
            arrivalWindow.label = `${arrivalWindow.from}-${arrivalWindow.to}`;
          });
          this.arrival_windows = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getSources() {
      axios
        .get(`values/sources?company_id=${this.lead.company_id}`) // TODO: set sources to vuex if needed
        .then(res => {
          this.sources = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getAddressData: _.debounce(function call(streetName, index) {
      if (streetName.length < 3) {
        this.$set(this.showDropdown, index, false);
      } else {
        if (typeof this.source !== typeof undefined) {
          this.source.cancel('Operation canceled due to new request.');
        }
        this.source = axios.CancelToken.source();
        this.$set(this.showDropdown, index, true);
        axios
          .get(
            `autocomplete?address=${encodeURIComponent(streetName)}`,
            // cancel token used by axios
            { cancelToken: this.source.token },
          )
          .then(res => {
            this.$set(this.addresses, index, res.data.data);
          })
          .catch(err => {
            if (!axios.isCancel(err)) {
              this.errors.record(err.response.data.error);
            }
          });
      }
    }, 500),
    setAddress(address, index) {
      axios
        .get(
          `geocode?place_id=${encodeURIComponent(address.place_id)}&address=${encodeURIComponent(
            address.full_address,
          )}`,
        )
        .then(res => {
          [address] = res.data.data;
          const addressNew = Object.assign(
            { type_id: this.lead.addresses[index].type_id },
            address,
          );
          this.$set(this.lead.addresses, index, addressNew);
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
      this.showDropdown[index] = false;
    },
    addAdditionalContact() {
      this.lead.contacts.push({});
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
      });
    },
    removeContact(index) {
      this.lead.contacts.splice(index, 1);
    },
    getNumberOfMovers() {
      axios
        .get(`/companies/${this.lead.company_id}/values/movers`)
        .then(res => {
          this.numberOfMovers = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    maskMainPhone(event) {
      this.$nextTick(() => {
        this.$set(
          this.lead,
          'phone',
          this.phoneMask.maskedPhone(this.lead.phone.replace(/\D/g, '')),
        );
        this.clearError(event);
      });
    },
    maskAdditionalPhone(index, event) {
      this.$nextTick(() => {
        this.$set(
          this.lead.contacts[index],
          'phone',
          this.phoneMask.maskedPhone(this.lead.contacts[index].phone.replace(/\D/g, '')),
        );
        this.clearError(event);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leads/LeadsCreate.vue